import icon1 from '../assets/img/DEIcon.svg'
import icon2 from '../assets/img/doge.svg'
import icon3 from '../assets/img/dot.svg'
import icon4 from '../assets/img/ESIcon.svg'
import icon5 from '../assets/img/eth.svg'

import s5 from '../assets/slider/crypto-Liquidity.jpg'
import s2 from '../assets/slider/GSHv4WVaUAYNZlE.jpg'
import s7 from '../assets/slider/Insights-into-Crypto-Volatility-and-its-Management.jpg'
import s9 from '../assets/slider/Learn-about-Pre-Markets-and-How-do-they-Work.jpg'
import s6 from '../assets/slider/NFT.jpg'
import s8 from '../assets/slider/Untitled-design.jpg'

import eff1 from '../assets/m-01.png'
import eff4 from '../assets/m2-01.png'
import eff3 from '../assets/m3-01.png'
import eff5 from '../assets/m4-01.png'
import eff2 from '../assets/m4-02.png'

export const icons = {
  icon1,
  icon2,
  icon3,
  icon4,
  icon5,
}

export const SliderImg = {
  s2,
  s5,
  s6,
  s7,
  s8,
  s9,
}

export const Effient = {
  eff1,
  eff2,
  eff3,
  eff4,
  eff5,
}
